/* eslint no-unused-vars:0 */

import axios from "axios";

export const incomeStreams = {
    namespaced: true,
    state: {
        incomeStreams: [],
        newPension: {
            id: null,
            individual_id: null,
            name: '',
            value: 0,
            stop_year_formula: 'life_exp',
            specific_year_to_stop: 0,
            specific_year_to_start: 0,
            specific_age_to_start: 0,
            start_year_formula: 'specific_year',
            pension_survivorship: 0,
            inflation_rate: 0,
            style_cd: 2,
        },
        newEmployment: {
            id: null,
            individual_id: null,
            name: '',
            value: 0,
            stop_year_formula: 'retirement',
            specific_year_to_stop: 0,
            specific_year_to_start: 0,
            specific_age_to_start: 0,
            start_year_formula: 'specific_year',
            pension_survivorship: 0,
            inflation_rate: 0,
            style_cd: 0,
        },
    },
    actions: {
        loadIncomeStreams ({ commit, getters, rootGetters }) {
            return axios
                .get('/api/household/' + rootGetters['auth/user'].household_id + '/income-streams')
                .then(response => {
                    return commit('setIncomeStreams', response.data.data.incomeStreams);
                })
                .then(() => {
                    let personTwoExists = rootGetters['individuals/personTwoExists'];
                    let personOne = rootGetters['individuals/personOne'];
                    let personTwo = rootGetters['individuals/personTwo'];

                    if (getters.personOnePension === undefined) {
                        commit('addPension', personOne);
                    }

                    if (getters.personTwoPension === undefined && personTwoExists) {
                        commit('addPension', personTwo);
                    }

                    if (getters.personOneEmployment === undefined) {
                        commit('addEmployment', personOne);
                    }

                    if (getters.personTwoEmployment === undefined && personTwoExists) {
                        commit('addEmployment', personTwo);
                    }
                });
        },

        saveIncomeStreams({ commit, getters, rootGetters }) {
            getters.incomeStreams.forEach((incomeStream, index) => {
                if (incomeStream.id === null) {
                    axios.post('/api/household/' + rootGetters['auth/user'].household_id + '/income-streams', incomeStream)
                        .then(response => {
                            const incomeStream = response.data.data.incomeStream;
                            delete incomeStream.individual;
                            commit('updateIncomeStream', { incomeStream, index });
                        });
                } else {
                    axios.put('/api/household/' + rootGetters['auth/user'].household_id + '/income-streams/' + incomeStream.id, incomeStream)
                        .then(response => {
                            const incomeStream = response.data.data.incomeStream;
                            delete incomeStream.individual;
                            commit('updateIncomeStream', { incomeStream, index });
                        });
                }
            });
        },

        deleteIncomeStream({ commit, getters, rootGetters }, { incomeStream, index }) {
            if (incomeStream.id === null) {
                return commit('deleteIncomeStream', { incomeStream, index });
            }

            return axios
                .delete('/api/household/' + rootGetters['auth/user'].household_id + '/income-streams/' + incomeStream.id)
                .then(response => {
                    commit('deleteIncomeStream', { incomeStream, index });
                    return response;
                })
        },

        addPension({ commit }, { person }) {
            commit("addPension", { person });
        },

        addEmployment({ commit }, { person }) {
            commit("addEmployment", { person });
        },
    },
    mutations: {
        addPension (state, person) {
            let newPension = {...state.newPension};
            newPension.individual_id = person.id;
            newPension.specific_age_to_start = person.current_age;

            state.incomeStreams.push(newPension);
        },
        addEmployment (state, person) {
            let newEmployment = {...state.newEmployment};
            newEmployment.individual_id = person.id;
            newEmployment.specific_age_to_start = person.current_age;

            state.incomeStreams.push(newEmployment);
        },
        setIncomeStreams (state, incomeStreams) {
            state.incomeStreams = incomeStreams;
        },
        addIncomeStream(state, incomeStream) {
            state.incomeStreams.push(incomeStream);
        },
        deleteIncomeStream(state, { incomeStream, index }) {
            if (incomeStream.id === null) {
                state.incomeStreams.splice(index);
            } else {
                state.incomeStreams = state.incomeStreams.filter(i => i.id !== incomeStream.id);
            }
        },
        updateIncomeStream(state, { incomeStream, index }) {
            state.incomeStreams.splice(index, 1, incomeStream);
        },
    },
    getters: {
        incomeStreams: state => state.incomeStreams,
        employments: state => state.incomeStreams.filter(i => i.style_cd === 0),
        socialSecurities: state => state.incomeStreams.filter(i => i.style_cd === 1),
        pensions: state => state.incomeStreams.filter(i => i.style_cd === 2),
        personOneEmployment: (state, getters, rootState, rootGetters) => getters.employments.find(i => i.individual_id === rootGetters['individuals/personOne']?.id),
        personTwoEmployment: (state, getters, rootState, rootGetters) => getters.employments.find(i => i.individual_id === rootGetters['individuals/personTwo']?.id),
        personOnePension: (state, getters, rootState, rootGetters) => getters.pensions.find(i => i.individual_id === rootGetters['individuals/personOne']?.id),
        personTwoPension: (state, getters, rootState, rootGetters) => getters.pensions.find(i => i.individual_id === rootGetters['individuals/personTwo']?.id),
        newPension: state => state.newPension,
    }
};
